import { useAuth } from "ls/features/user/useAuth";
import { usePostHog } from "ls/posthog/posthog";
import { watch } from "vue";

export function usePostHogIdentifyCurrentUser() {
  const { user: userRef } = useAuth();
  const posthog = usePostHog();

  watch(userRef, async user => {
    if (!user) return;
    posthog.identify(user.userId, {
      email: user.userEmail,
    });
  }, {
    immediate: true,
  });
}
